import * as Routes from '../../scripts/routes';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  IndexProcessoController = (currentUserId, $filter, $window) ->
    vm = @

    ### CONSTANTS ###

    ### VARIABLES VIEW MODEL ###
    vm.processosVisualizados = []

    ### VARIAVEIS PRIVATE ###

    ### WATCHES ###

    # INIT SETUP
    init = () =>
      getProcessosVisualizados()
      return

    ### METHODS PRIVATE ###
    getProcessosVisualizados = ->
      key = "processos_visualizados_#{currentUserId}"
      dados = JSON.parse($window.localStorage.getItem(key))
      if dados
        processos = Object.entries(dados).map(([key, value]) => value)
        processos.forEach((processo) => processo.timestamp = new Date(processo.visto_em).getTime())

        vm.processosVisualizados = processos

      return


    ### METHODS VIEW MODEL ###
    vm.getHrefVisualizarProcesso = (numero, params = {}) ->
      numero_ano = numero.replace('/', '_')
      return Routes.visualizar_processo_path(numero_ano, params)

    vm.getHrefMaterializarProcesso = (numero, params = {}) ->
      numero_ano = numero.replace('/', '_')
      return Routes.materializar_processo_path(numero_ano, params)

    vm.removerCard = (numero) ->
      vm.processosVisualizados = $filter('filter')(vm.processosVisualizados, {numero: "!#{numero}"})

      key = "processos_visualizados_#{currentUserId}"
      dados = JSON.parse($window.localStorage.getItem(key))
      $window.localStorage.setItem(key, JSON.stringify(vm.processosVisualizados)) if dados

      return

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'IndexProcessoController', IndexProcessoController

  # ANGULAR INJECT DEPENDENCIES
  IndexProcessoController.$inject = ['currentUserId', '$filter', '$window']

  # END BLOCK SCRIPT
  return
